import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { isMobile } from "react-device-detect";

export type StoreType = { name: string; mobile?: string; desktop?: string };

const DEFAULT_VALUES = [
  { name: "Google", desktop: "https://app.adjust.com/d7eg7ds" },
  { name: "Apple", desktop: "https://app.adjust.com/8ccc3ln" },
  { name: "Amazon", desktop: "https://app.adjust.com/ie3o8by" },
  {
    name: "Facebook",
    desktop:
      "https://apps.facebook.com/quickhitslots/?source=quickhitslots.com&campaign_id=badge",
  },
] as StoreType[];

const Stores = ({
  twoLines = false,
  links,
}: {
  twoLines?: boolean;
  links?: StoreType[];
}) => {
  const [stores, setStores] = useState([] as StoreType[]);
  const images = {
    Google: (
      <StaticImage
        className="hoverd-store"
        src="../images/stores/google.png"
        alt="Google Store"
        width={200}
        height={60}
      />
    ),
    Apple: (
      <StaticImage
        className="hoverd-store"
        src="../images/stores/apple.png"
        alt="Google Store"
        width={200}
        height={60}
      />
    ),
    Amazon: (
      <StaticImage
        className="hoverd-store"
        src="../images/stores/amazon.png"
        alt="Google Store"
        width={200}
        height={60}
      />
    ),
    Facebook: (
      <StaticImage
        className="hoverd-store"
        src="../images/stores/facebook.png"
        alt="Google Store"
        width={200}
        height={60}
      />
    ),
  };
  useEffect(
    () => setStores(links?.length ? links : DEFAULT_VALUES),
    [links?.length]
  );
  return (
    <div
      className={
        twoLines
          ? "grid grid-rows-2 grid-cols-2 gap-3"
          : "grid grid-rows-2 grid-cols-2 gap-x-3 gap-y-3 xl:grid-rows-1 xl:grid-cols-4"
      }
    >
      {stores?.map(({ name, desktop, mobile }) => {
        return (
          <a
            key={name}
            href={
              (isMobile && !!mobile ? mobile : desktop) ||
              DEFAULT_VALUES.find((item) => item.name === name)?.desktop
            }
            target="_blank"
          >
            {images[name]}
          </a>
        );
      })}
    </div>
  );
};

export default Stores;
